<template>
  <div>
    <v-container fluid>
      <v-row>

        <!-- Tasks -->
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="3"
          xl="3"
        >
          <v-card flat color="secondary" class="fill-height">
            <v-card-title>
              <h2 class="title white--text">משימות</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <tasks-due-today />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <orders-needs-finalizing />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <call-customer-today />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Collectings -->
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="3"
          xl="3"
        >
          <v-card flat color="grey lighten-4" class="fill-height">
            <v-card-title>
              <h2 class="title">איסופים היום</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <pickups-today from="LAMETAYEL" />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <pickups-today from="AIRPORT" />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <pickups-today from="OFFICE" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Problems -->
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
          xl="6"
        >
          <v-card flat color="red lighten-5" class="fill-height">
            <v-card-title>
              <h2 class="title">אי סדרים</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" class="pb-0">
                  <late-pickups />
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <late-returns />
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <late-device-validations />
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <orders-without-device-in-store />
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <invoices-not-sent />
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <DeactivatedDevicesInBookedOutOrders/>
                </v-col>
                <!--  
                <v-col cols="12" sm="6" class="pb-0">
                  <orders-with-deactivated-device />
                </v-col>-->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { format } from "date-fns";
import TasksDueToday from "@/components/dashboard/TasksDueToday";
import PickupsToday from "@/components/dashboard/PickupsToday";
import CallCustomerToday from "@/components/dashboard/CallCustomerToday";
import OrdersNeedsFinalizing from "@/components/dashboard/OrdersNeedsFinalizing";
import LatePickups from "@/components/dashboard/LatePickups";
import LateReturns from "@/components/dashboard/LateReturns";
import OrdersWithoutDeviceInStore from "@/components/dashboard/OrdersWithoutDeviceInStore";
import LateDeviceValidations from "@/components/dashboard/LateDeviceValidations";
import InvoicesNotSent from "@/components/dashboard/InvoicesNotSent";
import DeactivatedDevicesInBookedOutOrders from "@/components/dashboard/DeactivatedDevicesInBookedOutOrders"

export default {
  data() {
    return {};
  },

  computed: {},

  methods: {
    format
  },

  components: {
    TasksDueToday,
    PickupsToday,
    CallCustomerToday,
    OrdersNeedsFinalizing,
    LatePickups,
    LateReturns,
    OrdersWithoutDeviceInStore,
    LateDeviceValidations,
    InvoicesNotSent,
    DeactivatedDevicesInBookedOutOrders
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
